import { render, staticRenderFns } from "./ConfirmDialogCard.vue?vue&type=template&id=2052c7a9&scoped=true&"
import script from "./ConfirmDialogCard.vue?vue&type=script&lang=js&"
export * from "./ConfirmDialogCard.vue?vue&type=script&lang=js&"
import style1 from "./ConfirmDialogCard.vue?vue&type=style&index=1&id=2052c7a9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2052c7a9",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VCardActions,VCardText,VCardTitle,VIcon,VProgressCircular,VSpacer})


/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2052c7a9')) {
      api.createRecord('2052c7a9', component.options)
    } else {
      api.reload('2052c7a9', component.options)
    }
    module.hot.accept("./ConfirmDialogCard.vue?vue&type=template&id=2052c7a9&scoped=true&", function () {
      api.rerender('2052c7a9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Card/ConfirmDialogCard.vue"
export default component.exports